export default __webpack_public_path__ + "static/media/payment.95337fe8.jpg";